
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_14cnr_1qa2z_93",
  "trigger": "awsui_trigger_14cnr_1qa2z_108",
  "dropdown": "awsui_dropdown_14cnr_1qa2z_111",
  "nowrap": "awsui_nowrap_14cnr_1qa2z_122",
  "open": "awsui_open_14cnr_1qa2z_125"
};
  